module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/november/mainvisual-bg-sp_e5fc2709d35d9c156026610dffe826d7.png";